import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import type { Flashcard } from "@/types";

interface FlashcardDisplayProps {
  flashcards: Flashcard[];
}

export function FlashcardDisplay({ flashcards }: FlashcardDisplayProps) {
  const [flippedCards, setFlippedCards] = useState<Set<number>>(new Set());

  const toggleCard = (index: number) => {
    setFlippedCards((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  };

  if (flashcards.length === 0) {
    return <p className="text-sm text-muted-foreground">No flashcards available.</p>;
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {flashcards.map((flashcard, index) => {
        const isFlipped = flippedCards.has(index);
        return (
          <Card
            key={index}
            className="cursor-pointer transition-colors hover:bg-accent/50"
            onClick={() => toggleCard(index)}
            role="button"
            aria-expanded={isFlipped}
            aria-label={`Flashcard ${index + 1}: ${isFlipped ? "showing answer" : "click to reveal answer"}`}
          >
            <CardContent className="p-4">
              <div className="mb-1 text-xs font-medium uppercase text-muted-foreground">
                {isFlipped ? "Back" : "Front"}
              </div>
              <p className="text-sm">
                {isFlipped ? flashcard.back : flashcard.front}
              </p>
              {!isFlipped && (
                <p className="mt-2 text-xs text-muted-foreground">
                  Click to reveal answer
                </p>
              )}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
